var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"variant":_vm.variant,"pill":""}},[_vm._v("\n  "+_vm._s(_vm.certificaatStatus)+" "+_vm._s(_vm.geldigheidsduur)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }